export type Theme = 'light' | 'dark' | undefined;
let theme = $state<Theme>('light');

export function useThemeStore() {
	return {
		get value() {
			return theme;
		},
		set value(value: Theme) {
			theme = value;
		}
	};
}

export function setTheme(t: Theme) {
	if (t === 'light' || t === 'dark') {
		theme = t;
	}
}
